import { useState, useCallback } from 'react';
import { getSecuritySnapshot, SecuritySnapshot } from '../services/api';

interface UseSecuritySnapshotResult {
  snapshot: SecuritySnapshot | null;
  loading: boolean;
  error: string | null;
  fetchSnapshot: () => Promise<void>;
  refetch: () => Promise<void>;
}

export function useSecuritySnapshot(clientId: string | undefined): UseSecuritySnapshotResult {
  const [snapshot, setSnapshot] = useState<SecuritySnapshot | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSnapshot = useCallback(async () => {
    if (!clientId) return;

    setLoading(true);
    setError(null);

    try {
      const result = await getSecuritySnapshot(clientId);
      if (result.success && result.data) {
        setSnapshot(result.data);
      } else {
        setError(result.error || 'No security data available');
        setSnapshot(null);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch security data');
      setSnapshot(null);
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  return {
    snapshot,
    loading,
    error,
    fetchSnapshot,
    refetch: fetchSnapshot,
  };
}
